import { RiderGroupCurrentStateContract } from '@polaris-customerweb/sharedcomponents.core';
import { cloneDeep } from 'lodash-es';
import { RideGroupMessage } from './ride-group-message';
import { RideGroupRiderStatus } from './ride-group-rider-status';

export class RideGroupInfo {
    private contract: RiderGroupCurrentStateContract;
    private maxInactivePeriodSeconds: number;
    private riderId: string;
    private _messages: RideGroupMessage[];
    private _statuses: RideGroupRiderStatus[];

    constructor(
        contract: RiderGroupCurrentStateContract,
        riderId: string,
        maxInactivePeriodSeconds: number
    ) {
        this.contract = cloneDeep(contract);
        this.maxInactivePeriodSeconds = maxInactivePeriodSeconds;
        this.riderId = riderId;
    }

    get nextMessagesAfter(): string {
        return this.contract?.messageRooms?.[0]?.nextMessagesAfter ?? '';
    }

    get statuses(): RideGroupRiderStatus[] {
        if (!this._statuses) {
            this._statuses = (
                this.contract.membersAndFriends?.features ?? []
            ).map(
                (contract) =>
                    new RideGroupRiderStatus(
                        contract,
                        this.maxInactivePeriodSeconds
                    )
            );
        }
        return this._statuses;
    }

    get messages(): RideGroupMessage[] {
        if (!this._messages) {
            this._messages =
                this.contract?.messageRooms?.[0]?.messages?.map((contract) => {
                    const message = new RideGroupMessage(
                        contract,
                        this.contract?.messageRooms?.[0]?.senders?.find(
                            (sender) =>
                                sender.senderId === contract.fromSenderId
                        ) || {
                            color: 'Blue',
                            handle: 'Unknown',
                            riderId: '00000000-0000-0000-0000-000000000000',
                            senderId: '00000000-0000-0000-0000-000000000000',
                        }
                    );
                    message.isCurrentUserMessage =
                        this.riderId === message.riderId;
                    return message;
                }) || [];
        }
        return this._messages;
    }
}
